import { Check, ArrowDownRight } from "lucide-react";
import { Reveal } from "./Reveal";

const INCLUDES = [
  "One simple, transparent hourly rate",
  "Two-hour minimum booking",
  "Choose one-off, weekly or fortnightly",
  "The same trusted assistant, where possible",
  "Personalised support, always a real person",
  "No lock-in contracts",
];

export const Pricing = () => {
  const go = () => document.querySelector("#book")?.scrollIntoView({ behavior: "smooth" });
  return (
    <section id="pricing" data-testid="pricing-section" className="py-28 md:py-36 bg-[#EAE6DF]">
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid md:grid-cols-12 gap-12 items-center">
        <Reveal className="md:col-span-6">
          <p className="text-xs md:text-sm font-semibold tracking-[0.25em] uppercase text-[#C26D5C] mb-6">Simple pricing</p>
          <h2 className="font-serif font-light text-5xl md:text-6xl text-[#1A362D] tracking-tight leading-[1.05] max-w-lg">
            One rate. No surprises. Real support.
          </h2>
          <p className="mt-6 text-lg text-[#4A5A53] leading-relaxed max-w-md">
            We keep it refreshingly straightforward — a single hourly rate with a two-hour minimum,
            and personalised support to match the right assistant to your home.
          </p>
          <ul className="mt-8 space-y-3">
            {INCLUDES.map((item) => (
              <li key={item} className="flex items-center gap-3 text-[#1A362D]">
                <span className="w-6 h-6 rounded-full bg-[#D1DEC9] flex items-center justify-center shrink-0">
                  <Check size={14} className="text-[#1A362D]" />
                </span>
                {item}
              </li>
            ))}
          </ul>
        </Reveal>

        <Reveal delay={0.1} className="md:col-span-6">
          <div className="rounded-[2rem] bg-[#1A362D] text-[#F9F8F6] p-10 md:p-12 relative overflow-hidden grain">
            <p className="text-sm tracking-[0.2em] uppercase text-[#D1DEC9]">From</p>
            <div className="mt-4 flex items-end gap-2">
              <span className="font-serif text-8xl md:text-9xl leading-none">$55</span>
              <span className="font-serif text-3xl text-[#C26D5C] mb-3">/hr</span>
            </div>
            <p className="mt-4 text-[#D1DEC9]">Two-hour minimum · billed only for time booked</p>
            <div className="my-8 h-px bg-[#4A5A53]/50" />
            <p className="text-[#D1DEC9] leading-relaxed">
              Every home is different. Tell us what you need and we'll confirm a clear, personalised
              quote — no obligation.
            </p>
            <button
              data-testid="pricing-quote-button"
              onClick={go}
              className="group mt-8 inline-flex items-center gap-2 rounded-full bg-[#C26D5C] text-[#F9F8F6] px-7 py-4 text-sm font-medium hover:bg-[#A85D4E] transition-colors duration-300"
            >
              Get your free quote
              <ArrowDownRight size={18} className="group-hover:rotate-45 transition-transform duration-300" />
            </button>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
